import axios from 'axios';
import toCamelCase from '../utils/camelCase';
import getExpConfig from '../utils/getExpConfig';

export const patchDesign = (payload) => {
  const url = `${getExpConfig('base-api-url')}/pipfigurator/api/designs/save`;
  // const url = 'http://custom.localtest.me/pipfigurator/api/designs/save';
  const promise = axios.post(url, payload);
  return promise.then((response) => toCamelCase(response.data));
};

export const addItemProduct = async ({ designId, itemId, payload }) => {
  const url = `${getExpConfig(
    'base-api-url'
  )}/pipfigurator/designs/${designId}/items/${itemId}/product`;
  // const url = `http://custom.localtest.me/pipfigurator/designs/${designId}/items/${itemId}/product`;
  const promise = axios.post(url, payload);
  return promise.then((response) => toCamelCase(response.data));
};
